// Base URL for all API endpoints
export const BASE_URL = "https://api.sktinfracon.com"; // Ensure HTTPS is used to avoid CORS issues
//export const BASE_URL = "http://localhost:8080"; // Use localhost for development
// API endpoints configuration
export const API_ENDPOINTS = {
  baseURL: BASE_URL,
  
  // Employee endpoints
  employee: {
    list: `${BASE_URL}/api/employee/site`,
    count: `${BASE_URL}/api/employee/count`, 
    create: `${BASE_URL}/api/employee/create`,
    aadhar: `${BASE_URL}/api/employee/aadhar`,
    pan: `${BASE_URL}/api/employee/pan`,
    bank: `${BASE_URL}/api/employee/bank`,
    update: `${BASE_URL}/api/employee/update`,
    updateById: (empId) => `${BASE_URL}/api/employee/update/${empId}`,
    status: `${BASE_URL}/api/employee/status`,
    delete: `${BASE_URL}/api/employee/delete`,
    deleteById: (id) => `${BASE_URL}/api/employee/${id}`,
    searchByName: `${BASE_URL}/api/employee/search`,
    upload: `${BASE_URL}/api/employee/upload`,
    template: `${BASE_URL}/api/employee/template`,
    downloadTemplate: `${BASE_URL}/api/employee/download-template`,
  },
  
  // Attendance endpoints
  attendance: {
    list: `${BASE_URL}/api/attendance/site`,
    dateFilter: `${BASE_URL}/api/attendance/filter`,
    create: `${BASE_URL}/api/attendance/create`,
    update: `${BASE_URL}/api/attendance/update`,
    delete: `${BASE_URL}/api/attendance/delete`,
    deleteById: (id) => `${BASE_URL}/api/attendance/${id}`,
    upload: `${BASE_URL}/api/attendance/upload`,
    template: `${BASE_URL}/api/attendance/template`,
    downloadTemplate: `${BASE_URL}/api/attendance/download-template`,
    excel: `${BASE_URL}/api/attendance/excel`
  },

  employeefnf: {
    list: `${BASE_URL}/api/employeefnf`,
    create: `${BASE_URL}/api/employeefnf/create`,
    createSimple: `${BASE_URL}/api/employeefnf/create-simple`,
    byId: (id) => `${BASE_URL}/api/employeefnf/${id}`,
    byEmployee: (empId) => `${BASE_URL}/api/employeefnf/employee/${empId}`,
    dateRange: `${BASE_URL}/api/employeefnf/date-range`,
    document: `${BASE_URL}/api/employeefnf/document`,
    updateById: (id) => `${BASE_URL}/api/employeefnf/${id}`,
    deleteById: (id) => `${BASE_URL}/api/employeefnf/${id}`,
  },

  // Salary endpoints
  salary: {
    list: `${BASE_URL}/api/salary/site`,
    create: `${BASE_URL}/api/salary/create`,
    deleteById: (id) => `${BASE_URL}/api/salary/${id}`,
    updateById: (id) => `${BASE_URL}/api/salary/${id}`,
    dateRange: `${BASE_URL}/api/salary/date-range`,
    document: `${BASE_URL}/api/salary/document`
  },

  // Salary report endpoints
  salaryReport: {
    download: `${BASE_URL}/api/salary-report/download`
  },

  // Employee Advance endpoints
  employeeadvance: {
    list: `${BASE_URL}/api/employeeadvance/site`,
    count: `${BASE_URL}/api/employeeadvance/count`,
    create: `${BASE_URL}/api/employeeadvance/create`,
    update: `${BASE_URL}/api/employeeadvance/update`,
    delete: `${BASE_URL}/api/employeeadvance/delete`,
    deleteById: (id) => `${BASE_URL}/api/employeeadvance/${id}`,
    upload: `${BASE_URL}/api/employeeadvance/upload`,
    template: `${BASE_URL}/api/employeeadvance/template`,
    downloadTemplate: `${BASE_URL}/api/employeeadvance/download-template`,
    excel: `${BASE_URL}/api/employeeadvance/export`,
    dateFilter: `${BASE_URL}/api/employeeadvance/filter`
  },
  
  // Purchase endpoints
  purchase: {
    list: `${BASE_URL}/api/purchase/site`,
    count: `${BASE_URL}/api/purchase/count`,
    create: `${BASE_URL}/api/purchase/create`,
    update: `${BASE_URL}/api/purchase/update`,
    updateById: (id) => `${BASE_URL}/api/purchase/${id}`,
    delete: `${BASE_URL}/api/purchase/delete`,
    deleteById: (id) => `${BASE_URL}/api/purchase/${id}`,
    upload: `${BASE_URL}/api/purchase/upload`,
    template: `${BASE_URL}/api/purchase/template`,
    excel: `${BASE_URL}/api/purchase/excel`,
    dateFilter: `${BASE_URL}/api/purchase/excel`,
    dateRange: `${BASE_URL}/api/purchase/date-range`,
    invoice: `${BASE_URL}/api/purchase/invoice`,
    updatePaymentStatus: (purchaseNo, paymentStatus) => `${BASE_URL}/api/purchase/${purchaseNo}/payment-status?paymentStatus=${paymentStatus}`
  },
  
  // Sell endpoints
  sell: {
    list: `${BASE_URL}/api/sell/site`,
    count: `${BASE_URL}/api/sell/count`,
    create: `${BASE_URL}/api/sell/create`,
    update: `${BASE_URL}/api/sell/update`,
    updateById: (id) => `${BASE_URL}/api/sell/${id}`,
    delete: `${BASE_URL}/api/sell/delete`,
    deleteById: (id) => `${BASE_URL}/api/sell/${id}`,
    upload: `${BASE_URL}/api/sell/upload`,
    template: `${BASE_URL}/api/sell/template`,
    invoice: `${BASE_URL}/api/sell/invoice`,
    excel: `${BASE_URL}/api/sell/excel`,
    dateFilter: `${BASE_URL}/api/sell/excel`,
    dateRange: `${BASE_URL}/api/sell/date-range`,
    updatePaymentStatus: (sellNo, paymentStatus) => `${BASE_URL}/api/sell/${encodeURIComponent(sellNo)}/payment-status?paymentStatus=${encodeURIComponent(paymentStatus)}`
  },

  // Bill endpoints
  bill: {
    list: `${BASE_URL}/api/bill/site`,
    billNo: `${BASE_URL}/api/bill/search`,
    count: `${BASE_URL}/api/bill/count`,
    sum: `${BASE_URL}/api/bill/sum`,
    create: `${BASE_URL}/api/bill/create`,
    update: `${BASE_URL}/api/bill/update`,
    updateById: (id) => `${BASE_URL}/api/bill/${id}`,
    delete: `${BASE_URL}/api/bill/delete`,
    deleteById: (id) => `${BASE_URL}/api/bill/${id}`,
    upload: `${BASE_URL}/api/bill/upload`,
    template: `${BASE_URL}/api/bill/template`,
    excel: `${BASE_URL}/api/bill/excel`,
    dateFilter: `${BASE_URL}/api/bill/filter`,
    invoice: `${BASE_URL}/api/bill/invoice`
  },

  // Partnership endpoints
  partnership: {
    list: `${BASE_URL}/api/partnership/list`,
    site: `${BASE_URL}/api/partnership/site`,
    create: `${BASE_URL}/api/partnership/create`,
    updateById: (id) => `${BASE_URL}/api/partnership/${id}`,
    deleteById: (id) => `${BASE_URL}/api/partnership/${id}`,
    search: `${BASE_URL}/api/partnership/search`,
    dateRange: `${BASE_URL}/api/partnership/daterange`,
    sum: `${BASE_URL}/api/partnership/sum`,
    download: `${BASE_URL}/api/partnership/download`,
    byPartner: (partnerId) => `${BASE_URL}/api/partnership/partner/${partnerId}`
  },

  // Partner details endpoints
  partner: {
    create: `${BASE_URL}/api/partner-details/create`,
    site: `${BASE_URL}/api/partner-details/site`,
    updateById: (id) => `${BASE_URL}/api/partner-details/${id}`,
    deleteById: (id) => `${BASE_URL}/api/partner-details/${id}`,
    search: `${BASE_URL}/api/partner-details/search`
  },
  
  // Expense endpoints
  expense: {
    list: `${BASE_URL}/api/expense/site`,
    count: `${BASE_URL}/api/expense/count`,
    create: `${BASE_URL}/api/expense/create`,
    update: `${BASE_URL}/api/expense/update`,
    updateById: (id) => `${BASE_URL}/api/expense/${id}`,
    delete: `${BASE_URL}/api/expense/delete`,
    deleteById: (id) => `${BASE_URL}/api/expense/${id}`,
    upload: `${BASE_URL}/api/expense/upload`,
    uploadExcel: `${BASE_URL}/api/expense/upload`,
    template: `${BASE_URL}/api/expense/template`,
    downloadTemplate: `${BASE_URL}/api/expense/template`,
    excel: `${BASE_URL}/api/expense/excel`,
    dateFilter: `${BASE_URL}/api/expense/excel`,
    dateRange: `${BASE_URL}/api/expense/date-range`,
    document: `${BASE_URL}/api/expense/document`
  },

  // Management expense endpoints
  managementExpense: {
    list: `${BASE_URL}/api/management-expense/list`,
    site: `${BASE_URL}/api/management-expense/site`,
    count: `${BASE_URL}/api/management-expense/count`,
    create: `${BASE_URL}/api/management-expense/create`,
    createSimple: `${BASE_URL}/api/management-expense/create-simple`,
    updateById: (id) => `${BASE_URL}/api/management-expense/${id}`,
    deleteById: (id) => `${BASE_URL}/api/management-expense/${id}`,
    dateRange: `${BASE_URL}/api/management-expense/date-range`,
    document: `${BASE_URL}/api/management-expense/document`
  },
  
  // Work Order endpoints
  workorder: {
    list: `${BASE_URL}/api/workorder/site`,
    search: `${BASE_URL}/api/workorder/search`,
    count: `${BASE_URL}/api/workorder/count`,
    create: `${BASE_URL}/api/workorder/create`,
    update: `${BASE_URL}/api/workorder/update`,
    updateById: (id) => `${BASE_URL}/api/workorder/${encodeURIComponent(id)}`,
    getByWoNumber: (workOrder) => `${BASE_URL}/api/workorder/${workOrder}`,
    delete: `${BASE_URL}/api/workorder/delete`,
    deleteById: (id) => `${BASE_URL}/api/workorder/${id}`,
    upload: `${BASE_URL}/api/workorder/upload`,
    downloadDocument: `${BASE_URL}/api/workorder/document`
  },
  
  // Diesel endpoints
  diesel: {
    list: `${BASE_URL}/api/diesel/site`,
    count: `${BASE_URL}/api/diesel/count`,
    dieselInCount: (siteId) => `${BASE_URL}/api/fuel/diesel-in/count/${siteId}`,
    dieselOutCount: (siteId) => `${BASE_URL}/api/fuel/diesel-out/count/${siteId}`,
    create: `${BASE_URL}/api/diesel/create`,
    update: `${BASE_URL}/api/diesel/update`,
    delete: `${BASE_URL}/api/diesel/delete`,
    deleteById: (id) => `${BASE_URL}/api/diesel/${id}`,
    upload: `${BASE_URL}/api/diesel/upload`,
    template: `${BASE_URL}/api/diesel/template`,
    downloadTemplate: `${BASE_URL}/api/diesel/template`,
    excel: `${BASE_URL}/api/diesel/excel`,
    dateFilter: `${BASE_URL}/api/diesel/excel`
  },
  
  // Petrol endpoints
  petrol: {
    list: `${BASE_URL}/api/petrol/site`,
    count: `${BASE_URL}/api/petrol/count`,
    petrolInCount: (siteId) => `${BASE_URL}/api/fuel/petrol-in/count/${siteId}`,
    petrolOutCount: (siteId) => `${BASE_URL}/api/fuel/petrol-out/count/${siteId}`,
    create: `${BASE_URL}/api/petrol/create`,
    update: `${BASE_URL}/api/petrol/update`,
    delete: `${BASE_URL}/api/petrol/delete`,
    deleteById: (id) => `${BASE_URL}/api/petrol/${id}`,
    upload: `${BASE_URL}/api/petrol/upload`,
    template: `${BASE_URL}/api/petrol/template`,
    downloadTemplate: `${BASE_URL}/api/petrol/template`,
    excel: `${BASE_URL}/api/petrol/excel`,
    dateFilter: `${BASE_URL}/api/petrol/excel`
  },

  fueltransaction: {
    list: `${BASE_URL}/api/fuel/site`,
    count: `${BASE_URL}/api/fuel/count`,
    currentMonthDieselPetrolIn: (siteId) => `${BASE_URL}/api/fuel/site/current-month/diesel-petrol-in?siteid=${encodeURIComponent(siteId)}`,
    create: `${BASE_URL}/api/fuel/create`,
    update: `${BASE_URL}/api/fuel/update`,
    updateById: (id) => `${BASE_URL}/api/fuel/${id}`,
    delete: `${BASE_URL}/api/fuel/delete`,
    deleteById: (id) => `${BASE_URL}/api/fuel/${id}`,
    document: (id) => `${BASE_URL}/api/fuel/document?id=${encodeURIComponent(id)}`,
    upload: `${BASE_URL}/api/fuel/upload`,
    template: `${BASE_URL}/api/fuel/template`,
    excel: `${BASE_URL}/api/fuel/export`,
    dateFilter: `${BASE_URL}/api/fuel/export`,
    filter: `${BASE_URL}/api/fuel/filter`
  },

  fuelpump: {
    list: `${BASE_URL}/api/fuel-pump`,
    site: `${BASE_URL}/api/fuel-pump/site`,
    count: `${BASE_URL}/api/fuel-pump/count`,
    create: `${BASE_URL}/api/fuel-pump/create`,
    update: (id) => `${BASE_URL}/api/fuel-pump/${id}`,
    delete: `${BASE_URL}/api/fuel-pump/delete`,
    deleteById: (id) => `${BASE_URL}/api/fuel-pump/${id}`,
    document: (id) => `${BASE_URL}/api/fuel-pump/document?id=${encodeURIComponent(id)}`,
    upload: `${BASE_URL}/api/fuel-pump/upload`,
    template: `${BASE_URL}/api/fuel-pump/template`,
    downloadTemplate: `${BASE_URL}/api/fuel-pump/template`,
    excel: `${BASE_URL}/api/fuel-pump/excel`,
    dateFilter: `${BASE_URL}/api/fuel-pump/excel`,
    filter: `${BASE_URL}/api/fuel-pump/filter`,
    vehicle: (vehicleNumber) => `${BASE_URL}/api/fuel-pump/vehicle/${vehicleNumber}`,
    siteCount: `${BASE_URL}/api/fuel-pump/site/count`
  },

  fuelpayment: {
    list: `${BASE_URL}/api/fuel-payment`,
    site: `${BASE_URL}/api/fuel-payment/site`,
    byId: (id) => `${BASE_URL}/api/fuel-payment/${id}`,
    create: `${BASE_URL}/api/fuel-payment/create`,
    updateById: (id) => `${BASE_URL}/api/fuel-payment/${id}`,
    deleteById: (id) => `${BASE_URL}/api/fuel-payment/${id}`,
    dateRange: `${BASE_URL}/api/fuel-payment/date-range`,
    sum: `${BASE_URL}/api/fuel-payment/sum`,
    document: `${BASE_URL}/api/fuel-payment/document`
  },
  
  // Labour Coast endpoints
  labourcoast: {
    list: `${BASE_URL}/api/labourcoast/site`,
    count: `${BASE_URL}/api/labourcoast/count`,
    create: `${BASE_URL}/api/labourcoast/create`,
    update: `${BASE_URL}/api/labourcoast/update`,
    delete: `${BASE_URL}/api/labourcoast/delete`,
    deleteById: (id) => `${BASE_URL}/api/labourcoast/${id}`,
    upload: `${BASE_URL}/api/labourcoast/upload`,
    template: `${BASE_URL}/api/labourcoast/template`,
    excel: `${BASE_URL}/api/labourcoast/excel`,
    dateFilter: `${BASE_URL}/api/labourcoast/excel`
  },

  // Labour endpoints
  labour: {
    list: `${BASE_URL}/api/labour/site`,
    count: `${BASE_URL}/api/labour/count`,
    search: `${BASE_URL}/api/labour/search`,
    create: `${BASE_URL}/api/labour/create`,
    update: `${BASE_URL}/api/labour/update`,
    updateById: (id) => `${BASE_URL}/api/labour/${id}`,
    delete: `${BASE_URL}/api/labour/delete`,
    deleteById: (id) => `${BASE_URL}/api/labour/${id}`,
    status: `${BASE_URL}/api/labour/status`,
    upload: `${BASE_URL}/api/labour/upload`,
    template: `${BASE_URL}/api/labour/template`,
    excel: `${BASE_URL}/api/labour/export`,
    dateFilter: `${BASE_URL}/api/labour/export`
  },

  // Contractor endpoints
  contractor: {
    list: `${BASE_URL}/api/contractor/site`,
    count: `${BASE_URL}/api/contractor/count`,
    search: `${BASE_URL}/api/contractor/search`,
    create: `${BASE_URL}/api/contractor/create`,
    aadhar: `${BASE_URL}/api/contractor/aadhar`,
    pan: `${BASE_URL}/api/contractor/pan`,
    bank: `${BASE_URL}/api/contractor/bank`,
    update: `${BASE_URL}/api/contractor/update`,
    updateById: (id) => `${BASE_URL}/api/contractor/${id}`,
    status: `${BASE_URL}/api/contractor/status`,
    delete: `${BASE_URL}/api/contractor/delete`,
    deleteById: (id) => `${BASE_URL}/api/contractor/${id}`,
    upload: `${BASE_URL}/api/contractor/upload`,
    template: `${BASE_URL}/api/contractor/template`,
    excel: `${BASE_URL}/api/contractor/excel`,
    dateFilter: `${BASE_URL}/api/contractor/excel`
  },

  contractorwork: {
    list: `${BASE_URL}/api/contractor-work/site`,
    count: `${BASE_URL}/api/contractor-work/count`,
    create: `${BASE_URL}/api/contractor-work/create`,
    update: (id) => `${BASE_URL}/api/contractor-work/${id}`,
    delete: `${BASE_URL}/api/contractor-work/delete`,
    deleteById: (id) => `${BASE_URL}/api/contractor-work/${id}`,
    upload: `${BASE_URL}/api/contractor-work/upload`,
    template: `${BASE_URL}/api/contractor-work/template`,
    excel: `${BASE_URL}/api/contractor-work/excel`,
    dateFilter: `${BASE_URL}/api/contractor-work/excel`,
    dateRange: `${BASE_URL}/api/contractor-work/date-range`
  },

  contractorpayment: {
    list: `${BASE_URL}/api/contractor-payment/site`,
    count: `${BASE_URL}/api/contractor-payment/count`,
    sum: `${BASE_URL}/api/contractor-payment/sum`,
    create: `${BASE_URL}/api/contractor-payment/create`,
    update: (id) => `${BASE_URL}/api/contractor-payment/${id}`,
    delete: `${BASE_URL}/api/contractor-payment/delete`,
    deleteById: (id) => `${BASE_URL}/api/contractor-payment/${id}`,
    upload: `${BASE_URL}/api/contractor-payment/upload`,
    document: `${BASE_URL}/api/contractor-payment/document`,
    template: `${BASE_URL}/api/contractor-payment/template`,
    excel: `${BASE_URL}/api/contractor-payment/excel`,
    dateFilter: `${BASE_URL}/api/contractor-payment/excel`,
    dateRange: `${BASE_URL}/api/contractor-payment/date-range`
  },

  // LabourAdvance endpoints
  labouradvance: {
    list: `${BASE_URL}/api/labouradvance/site`,
    count: `${BASE_URL}/api/labouradvance/count`,
    create: `${BASE_URL}/api/labouradvance`,
    update: `${BASE_URL}/api/labouradvance/update`,
    delete: `${BASE_URL}/api/labouradvance/delete`,
    deleteById: (id) => `${BASE_URL}/api/labouradvance/${id}`,
    upload: `${BASE_URL}/api/labouradvance/upload`,
    template: `${BASE_URL}/api/labouradvance/template`,
    excel: `${BASE_URL}/api/labouradvance/export`,
    dateFilter: `${BASE_URL}/api/labouradvance/export`
  },

  // LabourAttendance endpoints
  labourattendance: {
    list: `${BASE_URL}/api/labourattendance/site`,
    count: `${BASE_URL}/api/labourattendance/count`,
    create: `${BASE_URL}/api/labourattendance/create`,
    update: `${BASE_URL}/api/labourattendance/update`,
    delete: `${BASE_URL}/api/labourattendance/delete`,
    deleteById: (id) => `${BASE_URL}/api/labourattendance/${id}`,
    upload: `${BASE_URL}/api/labourattendance/upload`,
    template: `${BASE_URL}/api/labourattendance/template`,
    excel: `${BASE_URL}/api/labourattendance/export`,
    dateFilter: `${BASE_URL}/api/labourattendance/export`
  },

  // LabourPayment endpoints
  labourpayment: {
    list: `${BASE_URL}/api/labourpayment/site`,
    count: `${BASE_URL}/api/labourpayment/count`,
    create: `${BASE_URL}/api/labourpayment/create`,
    update: `${BASE_URL}/api/labourpayment/update`,
    updateById: (id) => `${BASE_URL}/api/labourpayment/${id}`,
    delete: `${BASE_URL}/api/labourpayment/delete`,
    deleteById: (id) => `${BASE_URL}/api/labourpayment/${id}`,
    upload: `${BASE_URL}/api/labourpayment/upload`,
    template: `${BASE_URL}/api/labourpayment/template`,
    excel: `${BASE_URL}/api/labourpayment/export`,
    dateFilter: `${BASE_URL}/api/labourpayment/export`
  },

  // Concrete Production endpoints
  concreteproduction: {
    list: `${BASE_URL}/api/concrete-production/site`,
    count: `${BASE_URL}/api/concrete-production/count`,
    create: `${BASE_URL}/api/concrete-production/create`,
    update: `${BASE_URL}/api/concrete-production/update`,
    updateById: (id) => `${BASE_URL}/api/concrete-production/${id}`,
    delete: `${BASE_URL}/api/concrete-production/delete`,
    deleteById: (id) => `${BASE_URL}/api/concrete-production/${id}`,
    upload: `${BASE_URL}/api/concrete-production/upload`,
    template: `${BASE_URL}/api/concrete-production/template`,
    excel: `${BASE_URL}/api/concrete-production/export`,
    dateFilter: `${BASE_URL}/api/concrete-production/export`
  },
  
  // Sites endpoints
  sites: {
    list: `${BASE_URL}/api/sites`,
    search: `${BASE_URL}/api/sites/search`
  },

  // User management endpoints
  users: {
    activeUsers: `${BASE_URL}/api/auth/active-users`,
    deactivateUser: (userId) => `${BASE_URL}/api/auth/deactivate/${userId}`,
  },

  // Auth endpoints
  auth: {
    login: `${BASE_URL}/api/auth/login`,
    logout: `${BASE_URL}/api/auth/logout`,
    register: `${BASE_URL}/api/auth/create`,
    refresh: `${BASE_URL}/api/auth/refresh`,
    user: (username) => `${BASE_URL}/api/auth/user?username=${username}`,
    update: `${BASE_URL}/api/auth/update`
  }
};

// Helper function to get endpoint by type and action
export const getEndpoint = (type, action) => {
  return API_ENDPOINTS[type]?.[action] || null;
};

// Helper function to construct dynamic endpoints
export const constructEndpoint = (section, id) => {
  // Convert plural to singular if needed
  const sectionMap = {
    employees: "employee",
    attendance: "attendance",
    employeefnf: "employeefnf",
    purchases: "purchase",
    sells: "sell",
    bills: "bill",
    expenses: "expense",
    diesels: "diesel",
    petrels: "petrol",
    contractor: "contractor",
    contractorwork: "contractorwork",
    contractorpayment: "contractorpayment",
    managementExpense: "managementExpense",
  };
  
  const sectionKey = sectionMap[section] || section;
  
  if (typeof API_ENDPOINTS[sectionKey]?.deleteById === 'function') {
    return API_ENDPOINTS[sectionKey].deleteById(id);
  }
  return `${BASE_URL}/api/${sectionKey}/${id}`;
};
